<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item" aria-current="page">
                <router-link to="/stockin">{{$t('stock_in_list')}}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">[{{stockin.Num}}]</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <router-link v-if="!stockin.IsApproved" :to="{ name: 'stock_in_update', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-pencil"></i> {{$t('edit')}}</router-link>
            <button v-if="!stockin.IsApproved" type="button" class="btn btn-outline-primary btn-sm no-bor" @click="approveClick"><i class="fa fa-check"></i> {{ $t('approval') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="printClick"><i class="fa fa-print"></i> {{ $t('print') }}</button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <h3 class="text-center font-m">{{$t('stock_in')}}</h3>
                    <p class="text-center">{{$now().format('DD/MM/YYYY HH:mm A')}}</p>
                    <div class="row">
                        <div class="col-sm-6">
                            <table class="table-print">
                                <tbody>
                                    <tr>
                                        <td style="width: 100px;">{{ $t('branch_name') }}</td>
                                        <td style="width: 15px;">:</td>
                                        <td>{{branch.Name}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('receiver') }}</td>
                                        <td>:</td>
                                        <td>{{employee.KhmerName}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <table class="table-print" align="right">
                                <tbody>
                                    <tr>
                                        <td style="width: 100px;">{{ $t('code') }}</td>
                                        <td style="width: 15px;">:</td>
                                        <td style="min-width: 150px;">{{stockin.Num}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('date')}}</td>
                                        <td>:</td>
                                        <td>{{$format(stockin.InDateAt, 'DD/MM/YYYY')}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                                        <th>{{$t('item_name')}}</th>
                                        <th>{{$t('description')}}</th>
                                        <th style="width: 120px;">{{$t('uom')}}</th>
                                        <th class="text-center" style="width: 120px;">{{$t('qty')}}</th>
                                        <th class="text-center" style="width: 120px;">{{$t('qty_in')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret, index) in lines" :key="index">
                                        <td class="text-center">{{index + 1}}</td>
                                        <td>{{ret.ItemName}}</td>
                                        <td>{{ret.Description}}</td>
                                        <td>{{ret.UomName}}</td>
                                        <td class="text-center">{{ret.Quantity}}</td>
                                        <td class="text-center">{{ret.QuantityIn}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            branch: {},
            stockin: {
                IsApproved: true
            },
            employee: {
                KhmerName: ''
            },
            lines: []
        }
    },
    created(){
        var id = this.$route.params.id;
        if(id != undefined && id != null && id != ''){
            this.findById(id);
        }
    },
    methods: {
        findById(id){
            var loading = this.$loading.show();
            this.$api().post('stockin/find', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    var data = res.data.Data;
                    this.stockin = data.StockIn;
                    this.branch = data.Branch;
                    if(data.Employee != null)
                        this.employee = data.Employee;
                    this.lines = data.StockInLines;
                }
            }).finally(function() { loading.hide(); });
        },
        approveClick(){
            var loading = this.$loading.show();
            this.$api().post('stockin/approve', { Id: this.$route.params.id }).then(res => {
                if(this.$isValid(res)){
                    this.$router.push('/stockin');
                }
            }).finally(function() { loading.hide(); });
        },
        printClick(){
            window.open('/print/stockin/' + this.$route.params.id, '_blank');
        }
    }
}
</script>
<style scoped>
    .table-print thead tr th,
    .table-print tbody tr td{
        padding: 5px 0;
    }
</style>